const buildShipmentNavigationTargetUrl = ({
  activeSubPage = "details",
  recordId,
  status = "all",
}) => {
  const query = new URLSearchParams({ status: status || "all" });

  return `/shipments/${recordId}/${activeSubPage || "details"}?${query.toString()}`;
};

export { buildShipmentNavigationTargetUrl };
